import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["label", "href", "onClick", "disabled", "icon"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled from 'styled-components';
import { VisuallyHidden } from '../text';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IconButtonBase = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var label = _ref.label,
      href = _ref.href,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      icon = _ref.icon,
      props = _objectWithoutProperties(_ref, _excluded);

  var elementProps = _objectSpread({
    onClick: !disabled ? onClick : undefined
  }, props);

  var content = /*#__PURE__*/_jsxs(_Fragment, {
    children: [icon, /*#__PURE__*/_jsx(VisuallyHidden, {
      children: label
    })]
  });

  if (href && !disabled) {
    return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({}, elementProps), {}, {
      ref: ref,
      href: href,
      children: content
    }));
  }

  return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({}, elementProps), {}, {
    ref: ref,
    type: "button",
    disabled: disabled,
    children: content
  }));
});
IconButtonBase.displayName = 'IconButtonBase';
var IconButton = styled(IconButtonBase).withConfig({
  displayName: "IconButton",
  componentId: "sc-1w01a3h-0"
})(["display:inline-block;cursor:pointer;border:0;padding:0;background:transparent;&:focus{", "}", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.normalizeStyles(_objectSpread({}, theme.focus.outlines.withOffset));
}, function (_ref3) {
  var $styles = _ref3.$styles,
      theme = _ref3.theme;
  return theme.normalizeStyles($styles);
});
export default IconButton;